export default function ProUpgradeModal({
  isOpen,
  onClose,
  onUpgrade,
  featureName,
  isProcessing = false,
  ctaLabel = "Go Pro Now",
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal settings-modal">
        <div className="modal-header">
          <h2>Unlock Pro Features</h2>
          <button className="icon-btn" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="modal-body">
          {featureName && (
            <p style={{ marginBottom: "10px", fontWeight: 600 }}>
              <em>{featureName}</em> is a Pro-only feature.
            </p>
          )}
          <p>
            Thank you for using the Cross-Stitch Designer! The following
            advanced features are available exclusively to Pro users:
          </p>
          <ul
            style={{
              listStyleType: "disc",
              paddingLeft: "20px",
              lineHeight: "1.6",
            }}
          >
            <li>
              High-Resolution PNG + Key Export: Generate large, printable charts
              with color key and symbols.
            </li>
            <li>
              Custom Branding: Add your company logo and name to exported
              charts.
            </li>
            <li>
              Image-to-Stitch Conversion: Automatically convert imported images
              into a stitch pattern using intelligent color reduction and
              dithering.
            </li>
            <li>
              Find and Replace Tool: Globally change one color for another
              across all layers instantly.
            </li>
            <li>
              Palette Optimization: Reduce the color count, remap unused colors,
              and convert your palette between major thread brands (DMC/Anchor).
            </li>
          </ul>
          <p style={{ marginTop: "15px", fontWeight: "bold" }}>
            Click below to learn more about Pro features and complete your
            upgrade.
          </p>
        </div>
        <div className="modal-actions">
          <button className="btn" onClick={onClose}>
            Maybe Later
          </button>
          <button className="btn btn-primary" onClick={onUpgrade} disabled={isProcessing}>
            {isProcessing ? "Redirecting..." : ctaLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
